<div class="card">
    <app-header titulo="Clientes" descricao=""></app-header>
    <a [routerLink]="['novo']"><button icon="pi pi-plus" label="Novo Cliente" pButton></button></a>

    <div class="mt-3">
        <p-table [value]="clientes" dataKey="id">
            <ng-template pTemplate="header">
                <tr>
                    <th style="width: 50%">Razão Social</th>
                    <th style="width: 20%">CNPJ</th>
                    <th style="width: 20%">Status</th>
                    <th style="width: 10%"></th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-cliente>
                <tr>
                    <td>{{ cliente.razaoSocial }}</td>
                    <td>{{ cliente.cnpj }}</td>
                    <td><p-tag [value]="cliente.ativo ? 'Ativo' : 'Inativo'" [severity]="cliente.ativo ? 'success' : 'danger'"></p-tag></td>
                    <td>
                        <a [routerLink]="['editar', cliente.id]"><p-button icon="pi pi-arrow-up-right" severity="primary" class="m-1" aria-label="Acessar"></p-button></a>
                        <a ><p-button *ngIf="cliente.ativo" icon="pi pi-ban" severity="danger" class="m-1" aria-label="Bloquear" (click)="desativar(cliente.id)"></p-button></a>
                        <a ><p-button *ngIf="!cliente.ativo" icon="pi pi-check" severity="success" class="m-1" aria-label="Ativar" (click)="ativar(cliente.id)"></p-button></a>
                    </td>
                </tr>
            </ng-template>
    
        </p-table>
    </div>
</div>